import FooterPortal from 'volto-ministerio-publico-federal/components/Footer';

const Footer = () => {
  return <FooterPortal />;
};

export default Footer;
